import { createAction, props } from '@ngrx/store';



export enum DataInsightsActions {
    DATAINSIGHTS = '[DataInsights] Tr lib Data Insights data',
    DATAINSIGHTS_SUCCESS = '[Participants] Data Insights data success',
    DATAINSIGHTS_FAIL = '[Participants] Data Insights data fail',
  }


  export const dataInsights = createAction(
    DataInsightsActions.DATAINSIGHTS,
    props<{userID?: string }>()
  );
  
  export const dataInsightsLoadSuccess = createAction(
    DataInsightsActions.DATAINSIGHTS_SUCCESS,
    props<{res: any}>()
  );
  
  export const dataInsightsLoadLoadFail = createAction(
    DataInsightsActions.DATAINSIGHTS_FAIL,
    props<{error: unknown}>()
  );